<template lang="pug">
.service_card.d-flex.flex-column.flex-md-row
  .img_container.d-flex.align-items-center.justify-content-center
    .img_wrpper
      img.bg_default_gray.flex-grow-1(:src="item.Image")

  .content.d-none.d-md-block.flex-grow-1
    p.date.i_body {{ item.Date }}
    .depart.d-block
      span.i_body.departtment.i_mr_2 {{ item.Department }}
      span.i_body {{ item.Service }}
    .case
      span.i_body.i_mr_4(v-if="item.Number && item.Number != ''") 案號 {{ item.Number }}
      span.i_body(v-if="item.Insured && item.Insured != ''") 被保險人：{{ item.Insured }}
    p.desc.i_body_l(v-html="item.Content")
  .header.d-md-none.mobile
    .expand_btn.d-flex.justify-content-between.align-items-center(
      @click="expand",
      :class="{ expand: isExpand }"
    )
      p.date.i_body {{ item.Date }}

      svg-icon.i_ml_2.d-md-none(
        iconClass="arrow_bottom_g",
        className="arrow_bottom_g"
      )
    .depart.d-block
      span.i_body.departtment.i_mr_2 {{ item.Department }}
      span.i_body {{ item.Service }}
    .case
      span.i_body.i_mr_4(v-if="item.Number && item.Number != ''") 案號 {{ item.Number }}
      span.i_body(v-if="item.Insured && item.Insured != ''") 被保險人：{{ item.Insured }}
  .content.d-md-none.mobile.flex-grow-1(ref="content")
    p.desc.i_body_l(v-html="item.Content")
</template>

<script>
import Velocity from "velocity-animate";

export default {
  name: "Card",
  props: {
    item: Object,
  },
  data() {
    return {
      isExpand: false,
    };
  },
  mounted() {
    this.onResize();
  },
  methods: {
    onResize() {
      var thiz = this;

      window.onresize = function () {
        // 定義視窗大小變更通知事件
        thiz.$store.state.screenWidth = document.documentElement.clientWidth; //視窗寬度
      };
    },
    expand() {
      if (this.$store.state.screenWidth > 767) return;

      this.isExpand = !this.isExpand;

      if (this.isExpand) {
        //取得元素完整高度
        var height = this.$refs.content.scrollHeight + 40;

        Velocity(
          this.$refs.content,
          { maxHeight: height, opacity: 1 },
          { duration: 300 }
        );
      } else {
        Velocity(
          this.$refs.content,
          { maxHeight: 0, opacity: 0 },
          { duration: 300 }
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/thanks/card";
</style>
